<template>
  <main>
    <div class="container mt-4 mb-3">
      <div class="row">
        <div class="col-lg-11">
          <div class="text-block pt-0 pb-0">
            <h2>Table of Contents</h2>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="text-block pt-0 pb-0">
            <ul class="list-unstyled mb-0">
              <li><strong><router-link to="/aboutme/02/">
                02 About Me
              </router-link></strong></li>
              <li><strong><router-link to="/tenyearsin/03/">
                03 Ten Years In
              </router-link></strong></li>
              <li><strong><router-link to="/day1of3653/04/">
                04 Day 1 of 3653
              </router-link></strong></li>
              <br>
              <li><strong><router-link to="/places/06/">
                06 Places
              </router-link></strong></li>
              <li><router-link to="/places/07/">
                07 Beautiful Indiana barn I drove past at sunset
              </router-link></li>
              <li><router-link to="/places/08/">
                08 Reflection of Mount Moran at Oxbow Bend
              </router-link></li>
              <li><router-link to="/places/09/">
                09 David gazing at the mountains in Grand Teton National Park
              </router-link></li>
              <li><router-link to="/places/10/">
                10 Morning of our wedding at the dock
              </router-link></li>
              <li><router-link to="/places/11/">
                11 Crashing waves at Sunset Cliffs in San Diego
              </router-link></li>
              <li><router-link to="/places/12/">
                12 The view from the ferry to Ometepe Island on my honeymoon
              </router-link></li>
              <li><router-link to="/places/13/">
                13 Sunset view at the Lower Falls of Yellowstone River
              </router-link></li>
              <li><router-link to="/places/14/">
                14 Happened upon a moose on the trail in Grand Teton Natl Park
              </router-link></li>
              <li><router-link to="/places/15/">
                15 White horse on the shore of a kayak tour on my honeymoon
              </router-link></li>
              <li><router-link to="/places/16/">
                16 Vanessa taking in the view of Rabbit Island
              </router-link></li>
              <li><router-link to="/places/17/">
                17 Stream running through Grand Teton National Park
              </router-link></li>
              <li><router-link to="/places/18/">
                18 Young boy jumps off a dock at sunset on Ometepe Island
              </router-link></li>
              <li><router-link to="/places/19/">
                19 The best sunset I’ve ever seen, Ometepe Island, Nicaragua
              </router-link></li>
              <li><router-link to="/places/20/">
                20 Lake Michigan sunset from Saugatuck Dunes State Park
              </router-link></li>
              <li><router-link to="/places/21/">
                21 Self portrait from near the saddle of the Middle Teton
              </router-link></li>
              <li><router-link to="/places/22-23/">
                22 Sunset panorama of Bear Lake in Rocky Mountain Natl Park
              </router-link></li>
              <li><router-link to="/places/24/">
                24 Rural church in Auburn, WI
              </router-link></li>
              <li><router-link to="/places/25/">
                25 Man prays in the early morning at a church in Granada, NI
              </router-link></li>
              <li><router-link to="/places/26/">
                26 Michael gazing over Jenny Lake in Grand Teton National Park
              </router-link></li>
              <li><router-link to="/places/27/">
                27 Scissor graffiti on the Matilija Dam near Ojai, CA
              </router-link></li>
              <li><router-link to="/places/28/">
                28 Long exposure at Cowboy Cafe in Dubios, WY
              </router-link></li>
              <li><router-link to="/places/27/">
                29 Long exposure of the historic Logan Theatre sign
              </router-link></li>
              <li><router-link to="/places/30/">
                30 Fiery sunset at the Logan Theatre
              </router-link></li>
              <li><router-link to="/places/31/">
                31 Light streaks long exposure at LaSalle Bridge
              </router-link></li>
              <li><router-link to="/places/32/">
                32 Nicole at Balance Rock in Arches National Park
              </router-link></li>
              <li><router-link to="/places/33/">
                33 The historic Delicate Arch in Arches National Park
              </router-link></li>
              <li><router-link to="/places/34/">
                34 The Milky Way at Balance Rock
              </router-link></li>
              <li><router-link to="/places/35/">
                35 The Milky Way at Delicate Arch
              </router-link></li>
              <li><router-link to="/places/36/">
                36 Light painting the Rabbit Island sign
              </router-link></li>
              <li><router-link to="/places/37/">
                37 The Northern Lights dancing around at Rabbit Island
              </router-link></li>
              <br>
              <li><strong><router-link to="/people/38/">
                38 People
              </router-link></strong></li>
              <li><router-link to="/people/39/">
                39 Waiting on the Green Line
              </router-link></li>
              <li><router-link to="/people/40/">
                40 Riding the swings with some of my best friends at Navy Pier
              </router-link></li>
              <li><router-link to="/people/41/">
                41 Surfer does a backflip cliff jump
              </router-link></li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="text-block pt-0 pb-0">
            <ul class="list-unstyled">
              <li><router-link to="/people/42/">
                42 Double exposure portrait of Jon
              </router-link></li>
              <li><router-link to="/people/43/">
                43 Goodbye portrait of Buth leaving Rabbit Island
              </router-link></li>
              <li><router-link to="/people/44/">
                44 Stylized portrait of Esther at 63rd Street Beach
              </router-link></li>
              <li><router-link to="/people/45/">
                45 The 83rd portrait, Covert St. Brooklyn, NY
              </router-link></li>
              <li><router-link to="/people/46/">
                46 Portrait of the Rev. Dr. Tony Campolo
              </router-link></li>
              <li><router-link to="/people/47/">
                47 Portrait after Bethel Lutheran Church’s 125th Anniversary
              </router-link></li>
              <li><router-link to="/people/48/">
                48 Sarah at Chicago Botanic Gardens
              </router-link></li>
              <li><router-link to="/people/49/">
                49 Fall portrait of Nicole at Ohio Blvd in Terre Haute, IN
              </router-link></li>
              <li><router-link to="/people/50/">
                50 Portrait of my brother Matt in downtown Denver, CO
              </router-link></li>
              <li><router-link to="/people/51/">
                51 Company work retreat at Warren Dunes State Park
              </router-link></li>
              <li><router-link to="/people/52/">
                52 Swirling bokeh portrait of John in Logan Square
              </router-link></li>
              <li><router-link to="/people/53/">
                53 Anthony loves macaroons, Montreal, QC
              </router-link></li>
              <li><router-link to="/people/54/">
                54 Senior portrait of Kati in Provin Park, Grand Rapids, MI
              </router-link></li>
              <li><router-link to="/people/55/">
                55 Senior portrait of Camron in Grand Rapids, MI
              </router-link></li>
              <li><router-link to="/people/56/">
                56 Anthony &amp; Laura engagement session at Art Institute of Chicago
              </router-link></li>
              <li><router-link to="/people/57/">
                57 Sneakily shooting Jason’s engagement proposal to Blue
              </router-link></li>
              <li><router-link to="/people/58/">
                58 Portrait of Will at Chicago Music Exchange
              </router-link></li>
              <li><router-link to="/people/59/">
                59 Portrait of Jimmy in studio
              </router-link></li>
              <li><router-link to="/people/60/">
                60 Portrait of Charity while apple picking
              </router-link></li>
              <li><router-link to="/people/61/">
                61 Studio portrait of my first pet, my bearded dragon Richard Parker
              </router-link></li>
              <br>
              <li><strong><router-link to="/instantfilm/62/">
                62 Instant Film
              </router-link></strong></li>
              <li><router-link to="/instantfilm/63/">
                63 Portrait of Will at the Logan Square mural
              </router-link></li>
              <li><router-link to="/instantfilm/64/">
                64 Double exposure Polaroid portrait of The 83rd
              </router-link></li>
              <li><router-link to="/instantfilm/65/">
                65 Double exposure Polaroid portrait of Abbi Rajasekhar
              </router-link></li>
              <li><router-link to="/instantfilm/66/">
                66 Double exposure Polaroid of Anthony at the Wolfpack retreat
              </router-link></li>
              <li><router-link to="/instantfilm/67/">
                67 Double exposure Polaroid of Josh at the Wolfpack retreat
              </router-link></li>
              <li><router-link to="/instantfilm/68/">
                68 Double exposure Polaroid of Jason at the Wolfpack retreat
              </router-link></li>
              <li><router-link to="/instantfilm/69/">
                69 Polaroid negative portrait of Shiraz
              </router-link></li>
              <li><router-link to="/instantfilm/70/">
                70 Expired film Polaroid portrait of Nathanael at Lake Michigan
              </router-link></li>
              <li><router-link to="/instantfilm/71/">
                71 Polaroid of Andrew surfing at Rabbit Island
              </router-link></li>
              <li><router-link to="/instantfilm/72/">
                72 Double exposure Polaroid portrait of Rev. Dr. Tony Campolo
              </router-link></li>
              <li><router-link to="/instantfilm/73/">
                73 Double exposure Polaroid portrait of Jimmy Spencer Jr.
              </router-link></li>
              <li><router-link to="/instantfilm/74/">
                74 Polaroid portrait of my neighbor’s mother Goyita in studio
              </router-link></li>
              <li><router-link to="/instantfilm/75/">
                75 Negative Polaroid portrait of a little girl at New Moms
              </router-link></li>
              <li><router-link to="/instantfilm/76/">
                76 Instant film snapshot of Laura’s birthday party
              </router-link></li>
              <li><router-link to="/instantfilm/77/">
                77 How do I even describe this photo? No need.
              </router-link></li>
              <li><router-link to="/instantfilm/78/">
                78 Sneakily shot Polaroid of Jeff in French Lick, IN
              </router-link></li>
              <li><router-link to="/instantfilm/79/">
                79 Polaroid of Jeff &amp; Nicole processing at our wedding
              </router-link></li>
              <li><strong><router-link to="/endnotes/80/">
                80 Thank Yous, Colophon, &amp; Contact
              </router-link></strong></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <footer-block :next="next" :previous="previous"/>
  </main>
</template>

<script>
import FooterBlock from '@/components/blocks/FooterBlock';

export default {
  components: {
    FooterBlock,
  },
  props: {
    previous: String,
    next: String,
  },
  data() {
    return {
      routes: {},
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/templates/Contents.vue